export const BV_REVIEWS_LOADING = 'BV_REVIEWS_LOADING'; // eslint-disable-line
export const BV_REVIEWS_LOADED = 'BV_REVIEWS_LOADED';
